import React from "react";
import { Button, Modal } from "react-bootstrap";
import { Form, Formik } from "formik";
import axios from "src/config/axios";
import FormInputText from "src/components/Forms/FormInputText";
import GeneralFormError from "src/components/Forms/GeneralFormError";

const SendReservationSummaryDialog = ({ stay, handleClose, handleSuccess }) => {
  function submit(values, { setSubmitting, setErrors }) {
    axios
      .post(`/api/v1/stays/${stay.id}/send_reservation_summary.json`, {
        stay: values,
      })
      .then((response) => handleSuccess(response.data))
      .catch((error) => {
        setErrors(error.response?.data || { base: "Der Versand konnte nicht beauftragt werden." });
      })
      .finally(() => setSubmitting(false));
  }

  return (
    <Formik initialValues={{ contact_email: stay.contact_email || "" }} onSubmit={submit}>
      {({ errors, isSubmitting }) => (
        <Modal show={true} onHide={handleClose}>
          <Form>
            <Modal.Header closeButton>
              <Modal.Title>Aufenthaltsübersicht senden</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <GeneralFormError errors={errors} />
              <FormInputText name="contact_email" label="E-Mail" type="email" required />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>Abbrechen</Button>
              <Button type="submit" disabled={isSubmitting}>Senden</Button>
            </Modal.Footer>
          </Form>
        </Modal>
      )}
    </Formik>
  );
};

export default SendReservationSummaryDialog;
